import React from 'react'
import {FormattedDate} from 'react-intl'

import {Text} from '@daedalus/atlas/Text'
import {dateStringToMiddayDate} from '@daedalus/core/src/utils/date'

import {GuestAndRoomText} from './guestAndRooms'

export interface Props {
  checkIn?: string
  checkOut?: string
  rooms?: string
}

export const DateAndRoomsText = ({checkIn, checkOut, rooms}: Props) => {
  return (
    <>
      <Text variant="bodyS" colorPath="content.neutral.c600">
        {checkIn && checkOut && (
          <>
            <FormattedDate
              value={dateStringToMiddayDate(checkIn)}
              month="short"
              day="2-digit"
            />
            {' - '}
            <FormattedDate
              value={dateStringToMiddayDate(checkOut)}
              month="short"
              day="2-digit"
            />
          </>
        )}

        {checkIn && checkOut && rooms && <>{' · '}</>}

        {rooms && <GuestAndRoomText rooms={rooms} />}
      </Text>
    </>
  )
}
